import PropTypes from 'prop-types';

import {
  BlockInfo,
  HeaderInfo,
  ContentInfo,
} from './styled/DashboardInfo.styled';

import useDeviceType from '../../../juristec-ui/hooks/useDeviceType';
import CopyText from '../../../juristec-ui/core/CopyText';

import { formatDateTime } from '../../../juristec-ui/utils/functions/lab';

const DashboardInfo = ({
  dashboard,
}) => {
  const device = useDeviceType();

  return (
    <BlockInfo>
      <HeaderInfo>
        <span>Informações Principais</span>
      </HeaderInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Nome: </span>
          <span>{dashboard?.name || '-'}</span>
        </div>
        <div className="child-item">
          <CopyText
            text={dashboard?.id || '-'}
            textContainerStyle={
              {
                fontSize: '12px',
                fontWeight: 'normal',
                width: '300px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }
            }
          />
        </div>
      </ContentInfo>
      <ContentInfo>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Proprietário: </span>
          <span>{dashboard.ownerName || '-'}</span>
        </div>
        <div className="child-item">
          <CopyText
            text={dashboard?.owner || '-'}
            textContainerStyle={
              {
                fontSize: '12px',
                fontWeight: 'normal',
                width: '300px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }
            }
          />
        </div>
      </ContentInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>Criado em: </span>
          <span>{formatDateTime(dashboard?.created_at, { time: 'full' })}</span>
        </div>
      </ContentInfo>
      <ContentInfo device={device}>
        <div className="child-item">
          <span style={{ fontWeight: 'bold' }}>E-mail: </span>
          <span>{dashboard?.email || '-'}</span>
        </div>
      </ContentInfo>
    </BlockInfo>
  );
};

DashboardInfo.propTypes = {
  dashboard: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    owner: PropTypes.string,
    ownerName: PropTypes.string,
    created_at: PropTypes.shape({
      seconds: PropTypes.number,
      nanoseconds: PropTypes.number,
    }),
    email: PropTypes.string,
  }),
};

export default DashboardInfo;
